import { useEffect, useState } from "react";
import { Seo, SITE_URL } from "@/components/Seo";
import { useLang } from "@/i18n";
import { ProductRange } from "@/components/ProductRange";
import { ColourSpectrum } from "@/components/ColourSpectrum";

const API = process.env.REACT_APP_BACKEND_URL;

export default function GradesPage() {
  const { t, lang } = useLang();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/products`)
      .then((r) => r.json())
      .then((data) => setProducts(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, []);

  const gradesJsonLd =
    products.length > 0
      ? {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Clara Cocoa Powder Grades",
          numberOfItems: products.length,
          itemListElement: products.map((p, i) => ({
            "@type": "ListItem",
            position: i + 1,
            item: {
              "@type": "Product",
              name: `Clara Cocoa Powder ${p.code}`,
              image: p.image && p.image.startsWith("/") ? `${SITE_URL}${p.image}` : p.image,
              url: `${SITE_URL}/${lang}/grades/${p.code}`,
              category: "Cocoa Powder",
              brand: { "@type": "Brand", name: "Clara" },
              description: `${p.type} cocoa powder — ${p.color}, pH ${p.ph}.`,
              additionalProperty: [
                { "@type": "PropertyValue", name: "Process", value: p.type },
                { "@type": "PropertyValue", name: "Colour", value: p.color },
                { "@type": "PropertyValue", name: "pH", value: p.ph },
              ],
            },
          })),
        }
      : null;

  return (
    <>
      <Seo title={t.seo.grades.title} description={t.seo.grades.description} path="/grades" jsonLd={gradesJsonLd} />
      <ProductRange h1 />
      <ColourSpectrum />
    </>
  );
}
